import { render, staticRenderFns } from "./FeaturedSliderPanelMobile.vue?vue&type=template&id=7463ce2a&scoped=true&"
import script from "./FeaturedSliderPanelMobile.vue?vue&type=script&lang=js&"
export * from "./FeaturedSliderPanelMobile.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedSliderPanelMobile.vue?vue&type=style&index=0&id=7463ce2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463ce2a",
  null
  
)

export default component.exports